import * as types from '../mutation-types'
import GlobalFunctions from '../../global'

const state = {
	googleFonts: []
}

export const getters = {
	allGoogleFonts: state => state.googleFonts
}

export const actions = {
	getGoogleFonts ({ commit }) {
		return GlobalFunctions.getGoogleFonts().then(response => {
			commit(types.SET_GOOGLE_FONTS, {
				fonts: response.items
			})
		}).catch(reason => {
			// No catch
		})
	}
}

export const mutations = {
	[types.SET_GOOGLE_FONTS] (state, payload) {
		state.googleFonts = payload.fonts
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/google.js